module.exports = __webpack_public_path__ + "img/L_1S.0808056e.png";